const KEY = "fitsmith_active_training";

export function saveActiveTraining(route, label, startedAt, state) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ route, label, startedAt, state }));
  } catch {}
}

export function getActiveTraining() {
  try {
    const d = JSON.parse(sessionStorage.getItem(KEY));
    return d?.route ? d : null;
  } catch {
    return null;
  }
}

export function clearActiveTraining() {
  try {
    sessionStorage.removeItem(KEY);
  } catch {}
}
